import ApiService from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';
import ftosCommitTypes from './commit-types';

const ftosActionCreators = {
  fetchFtos() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchFtos'));
      const data = await ApiService.get('/api/v1/ftos?status=completed,pending,opened')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchFtos'));
      if (data) {
        dispatch(this.fetchFtosSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchFtosSuccess(ftosResponse) {
    return (dispatch) => {
      dispatch(this.pushFtos(ftosResponse.data));
    };
  },
  fetchFtosForTrainingPhase(phaseGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchFtosForTrainingPhase'));
      const data = await ApiService.get(`/api/v1/training-phases/${phaseGuid}/assign`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchFtosForTrainingPhase'));
      if (data) {
        dispatch(this.fetchFtosForTrainingPhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchFtosForTrainingPhaseSuccess(ftosResponse) {
    return (dispatch) => {
      dispatch(this.pushFtos(ftosResponse.data));
    };
  },
  resetFtosState() {
    return {
      type: ftosCommitTypes.RESET_FTOS_STATE,
    };
  },
  pushFtos(list) {
    return {
      list,
      type: ftosCommitTypes.PUSH_FTOS,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: ftosCommitTypes.SET_FTOS_IS_LOADING,
    };
  },
  unmountFtosContainer() {
    return {
      type: ftosCommitTypes.RESET_FTOS_STATE,
    };
  },
};

export default ftosActionCreators;
